import React from 'react';
import { cn } from '../../../../../lib/utils';
import {
  borderGrey,
  darkerBG,
  semiBoldText,
  smallTextSize,
  tertiaryText,
} from '../../../../../styling/stylingHelper';

/** Panel that wraps the body of every detail-panel section. */
export const sectionPanelClass = cn('border rounded-xl sm:rounded-2xl', borderGrey, darkerBG);

/** Row card sitting inside a section panel (e.g. one restaurant). */
export const sectionRowClass = cn('bg-background dark:bg-background-dark rounded-xl p-3 sm:p-4');

export const SectionHeading: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <h3 className={cn(smallTextSize, semiBoldText, tertiaryText, 'leading-6 uppercase')}>{children}</h3>
);
